import { put, takeLatest, call } from "redux-saga/effects";
import {
    FORWARD_BOTS_FOR_ADMIN_SUCCESS,
    FORWARD_BOTS_FOR_ADMIN,
    FORWARD_BOTS_FOR_ADMIN_FAILED
} from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import { makeSecuredPostRequest } from "../../../appApi/AppApi";
import { createActionOf } from "../../actions/ActionCreator";

const TAG = "get_approved_bots_for_admin.js";

function* workerForwardBots(payLoad) {
  // console.log("payload sub-------------------->",payLoad.data.data);
  try {
    const response = yield call(
      makeSecuredPostRequest,
      API_ENDPOINT.FORWARD_BOTS_FOR_ADMIN,
      payLoad.data
    );
    yield put(createActionOf(FORWARD_BOTS_FOR_ADMIN_SUCCESS, 1, response));
  } catch (error) {
    console.error(TAG, "Worker forward bots failed: " + error.message);
    yield put(createActionOf(FORWARD_BOTS_FOR_ADMIN_FAILED, 2, error));
  }
}

export const watchForwardBots = takeLatest(
    FORWARD_BOTS_FOR_ADMIN,
  workerForwardBots
);
